import {
  Modal,
  Stack,
  Button,
  TextInput,
  Group,
  Text,
  ActionIcon,
  Alert,
} from "@mantine/core";
import {
  IconCopy,
  IconTrash,
  IconExternalLink,
  IconInfoCircle,
} from "@tabler/icons-react";
import {
  useCreateShareLink,
  useDeleteShareLink,
  useGetShareLink,
} from "../../api/polls";
import { notifications } from "@mantine/notifications";
import { useClipboard } from "@mantine/hooks";

export default function SharePollResultsModal({ pollId, opened, onClose }) {
  const { data: shareLink, isLoading } = useGetShareLink(pollId);
  const { mutate: createLink, isPending: isCreating } =
    useCreateShareLink(pollId);
  const { mutate: deleteLink, isPending: isDeleting } =
    useDeleteShareLink(pollId);

  const handleCreateLink = () => {
    createLink({});
  };

  const handleDeleteLink = () => {
    deleteLink({});
  };
  const clipboard = useClipboard();

  const handleCopyLink = () => {
    clipboard.copy(shareLink?.shareUrl);
    notifications.show({
      title: "Copied",
      message: "Link copied to clipboard",
      color: "green",
    });
  };

  const handleOpenLink = () => {
    window.open(shareLink?.shareUrl, "_blank");
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Share Poll Results"
      size="lg"
    >
      <Stack gap="md">
        <Alert icon={<IconInfoCircle size={16} />} color="blue" variant="light">
          Share poll results publicly with anyone. The link will display
          real-time results and auto-refresh every 5 seconds.
        </Alert>

        {!shareLink?.shareToken ? (
          <Button
            onClick={handleCreateLink}
            loading={isCreating || isLoading}
            leftSection={<IconExternalLink size={16} />}
          >
            Create Share Link
          </Button>
        ) : (
          <Stack gap="sm">
            <Text size="sm" fw={500}>
              Public Link
            </Text>
            <Group gap="xs">
              <TextInput
                value={shareLink.shareUrl}
                readOnly
                style={{ flex: 1 }}
              />
              <ActionIcon
                variant="light"
                color="blue"
                size="lg"
                onClick={handleCopyLink}
              >
                <IconCopy size={18} />
              </ActionIcon>
              <ActionIcon
                variant="light"
                color="green"
                size="lg"
                onClick={handleOpenLink}
              >
                <IconExternalLink size={18} />
              </ActionIcon>
              <ActionIcon
                variant="light"
                color="red"
                size="lg"
                onClick={handleDeleteLink}
                loading={isDeleting}
              >
                <IconTrash size={18} />
              </ActionIcon>
            </Group>
          </Stack>
        )}
      </Stack>
    </Modal>
  );
}
